import { ApiJobId } from 'api/types/ApiTypedId';
import { SearchAlgoliaHit } from 'modules/search/algolia/types/SearchAlgoliaHit';
import { SearchHit } from 'modules/search/components/Hit/SearchHit';
import { algoliaTrackClick } from 'utils/algolia/algoliaTrackClick';
import { trackClicked } from 'utils/analytics/track/trackClicked';

type Props = {
  jobId: ApiJobId;
  queryID: string | undefined;
  hits: SearchAlgoliaHit[];
  page: number;
  hitsPerPage: number;
};

export function ViewJobPageSidebarSuggestionsHits({
  jobId,
  queryID,
  hits,
  page,
  hitsPerPage,
}: Props) {
  return (
    <>
      {hits.map((hit, index) => (
        <SearchHit
          key={hit.objectID}
          hit={hit}
          hideOwnerBanner
          highlighted={jobId === hit.objectID}
          trackClick={() => {
            // Position in algolia analytics is 1-indexed
            const hitIndex = page * hitsPerPage + index + 1;

            algoliaTrackClick(queryID, hit.objectID, hitIndex);

            trackClicked('Search Result', {
              org_id: 'orgID' in hit ? hit.orgID : undefined,
              org_type: 'orgType' in hit ? hit.orgType : undefined,
              result_id: hit.objectID,
              result_index: index,
              result_type: hit.type,
            });
          }}
        />
      ))}
    </>
  );
}
